import React from 'react';
import VideoTutorialFunctional from './components/video-tutorial-functional';
//import scss if needed
const VideoTutorialPage = () => {
	return <VideoTutorialFunctional />;
};
export default VideoTutorialPage;
